module.exports = __webpack_public_path__ + "static/media/tier-3.ae41e6c6.jpg";